export const kConversationListCacheDuration = 60 * 1000 // Cache Duration - 60 seconds
export const kConversationRefreshCacheDuration = 5 * 1000 // Refresh Cache Duration - 5 seconds
export const kNewConversationTitle = 'New Chat'
